import Vue from "vue";
import axios from "axios";
import requestHandler from "../api/RequestHandling";

let openai = new Vue({
  data() {
    return {
      gptRes: null,
    };
  },
  components: {
    requestHandler,
  },
  methods: {
    async askChatGPT(gptPrompt) {
      let resp;
      let params = {
        prompt: gptPrompt,
      };
      await this.$requestHandling
        .post(this.$requestHandling.backend_url + "openai/askChatGPT", params)
        .then((response) => {
          this.gptRes = response;
        });
      return this.gptRes;
    },

    async livesign() {
      let resp;
      await this.$requestHandling
        .get(this.$requestHandling.backend_url + "openai")
        .then((response) => {
          this.gptRes = response;
        });
      return this.gptRes;
    },
  },
});

export default {
  install: function (Vue) {
    Vue.prototype.$openai = openai;
  },
};
